import { render, staticRenderFns } from "./MailView.vue?vue&type=template&id=25f91b22&scoped=true"
import script from "./MailView.vue?vue&type=script&lang=js"
export * from "./MailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f91b22",
  null
  
)

export default component.exports